import React, { useEffect, useMemo, useRef, useState } from "react";
import { IonPage, IonContent, IonHeader, IonToolbar, IonTitle, IonButton, IonIcon, IonButtons, IonBackButton } from "@ionic/react";
import HeaderComponent from "../../components/HeaderComponent";
import { paperPlaneOutline } from "ionicons/icons";
import BackButton from '../../shared/assets/icons/back-button.svg';
import { useChatPolling } from "../../shared/lib/hook/useChatPolling";
import { useParams } from "react-router";
import { sendMessages } from "../../entities/chat/api/message";
import { ChatMessage } from "../../entities/chat";
type ChatRole = "waiter" | "user" | "system";

const formatTime = (iso: string) =>
  new Date(iso).toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit" });

const makeId = () => `${Date.now()}_${Math.random().toString(16).slice(2)}`;

const OrderChat: React.FC = () => {
  const {orderId} = useParams<{ orderId: string }>()
  const [text, setText] = useState("");
  const { messages, isLoading, addMessage } =  useChatPolling(orderId, 6000);
  const editorRef = useRef<HTMLDivElement | null>(null);


  const bottomRef = useRef<HTMLDivElement | null>(null);

  const canSend = useMemo(() => text.trim().length > 0, [text]);

  const scrollToBottom = () => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages.length]);

  const sendMessage =async () => {
    if (!canSend) return;
    const data={
        orderId,
        content:text.trim()
    }
    const msg= await sendMessages(data)
   
    setText("");
    if (editorRef.current) {
        editorRef.current.textContent = "";
    }
    addMessage(msg);

  };

  const onKeyDown: React.KeyboardEventHandler<HTMLInputElement> = (e) => {
    if (e.key === "Enter") sendMessage();
  };

  return (
    <IonPage>
    <IonHeader className="!bg-white second__toolbar">
        <IonToolbar className="px-3 ">
            <IonTitle>Чат с клиентом</IonTitle>
            <IonButtons slot="start">
                <IonBackButton text="" icon={BackButton}></IonBackButton>
            </IonButtons>
            
        </IonToolbar>
    </IonHeader>
      <IonContent className="bg-slate-100">
        <div className="mx-auto flex h-full max-w-md flex-col px-3 pt-3 pb-24">
          <div className="flex-1 space-y-2 overflow-y-auto">
            {messages.map((m) => (
              <MessageBubble key={m.id} m={m} />
            ))}
            <div ref={bottomRef} />
          </div>

          <div className="fixed bottom-0 left-0 right-0 flex justify-center bg-transparent">
            <div className="w-full max-w-md px-3 pb-3">
              <div className="flex items-center gap-2 rounded-2xl bg-white p-2 shadow-[0_-6px_20px_rgba(15,23,42,0.12)]">
                <div
                    ref={editorRef}
                    contentEditable
                    data-placeholder="Написать сообщение..."
                    suppressContentEditableWarning
                    onInput={(e) => setText(e.currentTarget.textContent || "")}
                    onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                        e.preventDefault();
                        sendMessage();
                    }
                    }}
                    className="
                    min-h-[40px]
                    max-h-[120px]
                    flex-1
                    overflow-y-auto
                    rounded-xl
                    bg-slate-50
                    px-3
                    py-2
                    text-sm
                    outline-none
                    break-words
                    "
                />
                
                <button
                  onClick={sendMessage}
                  disabled={!canSend}
                  className="h-[35px] w-[45px] flex items-center text-white px-0 text-center bg-blue-500 rounded-2xl p-0 m-0  "
                >
                  <IonIcon icon={paperPlaneOutline} className="m-auto"></IonIcon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default OrderChat;

const MessageBubble: React.FC<{ m: ChatMessage }> = ({ m }) => {
  if (m.senderType === "system") {
    return (
      <div className="flex justify-center">
        <div className="rounded-full bg-slate-200 px-3 py-1 text-[11px] text-slate-600">
          {m.content}
        </div>
      </div>
    );
  }

  const isMine = m.senderType === "restaurant";

  return (
    <div className={`flex ${isMine ? "justify-end" : "justify-start"}`}>
      <div
        className={[
          "max-w-[85%] rounded-2xl px-3 py-2 shadow-sm",
          isMine ? "bg-blue-600 text-white rounded-br-md" : "bg-white text-slate-900 rounded-bl-md",
        ].join(" ")}
      >
        {!isMine && m.senderName && (
          <div className="mb-1 text-[10px] font-semibold text-slate-500">
            {m.senderName}
          </div>
        )}

        <div className="text-sm leading-snug whitespace-pre-wrap break-words">
          {m.content}
        </div>

        <div className={`mt-1 text-[10px] ${isMine ? "text-white/70" : "text-slate-400"} text-right`}>
          {formatTime(m.createdAt)}
        </div>
      </div>
    </div>
  );
};
